import React from 'react';
import {Button, Divider, Form, Input, InputNumber, message, Modal, Select, Table, Tag} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";

const { Option } = Select;

const blockchainList = ['ERC20', 'BSC', 'HECO'];
const paymentStatusList = [
    {value: 1, label: 'PENDING'},
    {value: 2, label: 'SUCCEEDED'},
    {value: 3, label: 'TIMEOUT'},
    {value: 4, label: 'CANCELED'}
];

export default class CryptoOrderList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            showOrderInfoDialog: false,
            showResourcesDialog: false,
            showMessageDialog: false,
            showRechargeModal: false,
            showAddResourceModal: false,
            showConfirmModal: false,
            showEditOrderModal: false,
            confirmLoading: false,
            editLoading: false,
            loading: false,
            dataList: [],
            resources: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            planList: [],
            paymentStatusList: [],
            paymentWayList: [],
            selectedOrder: {},
            query_params: {},
            edit_order_params: {},
            form_refund_params: {},
            form_recharge_params: {},
            form_resource_params: {}
        }
    }

    componentDidMount() {
        this.loadListData();
        this.loadPaymentStatusList();
    }

    setStateParams(params, name, value) {
        params[name] = value;
        this.setState(params);
    }

    setQueryParam(name, value) {
        this.setState({
            query_params: Object.assign({}, this.state.query_params, {[name]: value})
        });
    }

    setEditOrderParam(name, value) {
        this.setState({
            edit_order_params: Object.assign({}, this.state.edit_order_params, {[name]: value})
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData(changedParams) {
        const pagination = changedParams && changedParams.currentPage ? changedParams : {
            currentPage: 1,
            pageSize: this.state.pageSize
        };
        const params = Object.assign({}, this.state.query_params, pagination);

        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/crypto-order-list', params)
            .then(response => {
                console.debug("crypto-order-list response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({
                        dataList: response.rows,
                        total: response.total,
                        currentPage: pagination.currentPage,
                        pageSize: pagination.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    openEditOrderModal(record) {
        if (this.isSucceededOrder(record)) {
            return;
        }
        this.setState({
            showEditOrderModal: true,
            selectedOrder: record,
            edit_order_params: {
                blockchain: record.blockchain,
                tokenName: record.tokenName || '',
                tokenAmount: record.tokenAmount === null || typeof record.tokenAmount === 'undefined' ?
                    undefined : Number(record.tokenAmount),
                paymentStatus: Number(record.paymentStatus)
            }
        });
    }

    updateCryptoOrder() {
        const params = this.state.edit_order_params;
        const tokenName = (params.tokenName || '').trim();
        const tokenAmount = Number(params.tokenAmount);

        if (blockchainList.indexOf(params.blockchain) < 0) {
            message.warn('Blockchain is required.');
            return;
        }
        if (!tokenName) {
            message.warn('Token name is required.');
            return;
        }
        if (!Number.isFinite(tokenAmount) || tokenAmount <= 0) {
            message.warn('Token amount must be greater than 0.');
            return;
        }
        if (paymentStatusList.map(item => item.value).indexOf(params.paymentStatus) < 0) {
            message.warn('Payment status is required.');
            return;
        }

        const request = {
            blockchain: params.blockchain,
            tokenName: tokenName.toUpperCase(),
            tokenAmount: tokenAmount,
            paymentStatus: params.paymentStatus
        };
        this.setState({editLoading: true});
        new WebServerRestClient().PUT(
            '/admin/crypto-orders/' + this.state.selectedOrder.orderId,
            request
        ).then(response => {
            this.setState({editLoading: false});
            if (response.code === 200) {
                this.setState({showEditOrderModal: false});
                message.success('Crypto order updated.');
                this.loadListData({
                    currentPage: this.state.currentPage,
                    pageSize: this.state.pageSize
                });
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(this.getErrorMessage(response));
            }
        }).catch(err => {
            this.setState({editLoading: false});
            message.error('Error: ' + err.message);
        });
    }

    getErrorMessage(response) {
        return response.message || response.msg || 'Request failed';
    }

    isSucceededOrder(record) {
        return Number(record.paymentStatus) === 2 ||
            String(record.paymentStatusText || '').toUpperCase() === 'SUCCEEDED';
    }

    loadUserResources(userId) {
        this.setState({showResourcesDialog: true});
        new WebServerRestClient().GET('/admin/user/resources/' + userId)
            .then(response => {
                console.debug("user/resources response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({resources: response.data, loading: false})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    loadPaymentStatusList() {
        new WebServerRestClient().GET('/admin/dict/crypto-payment-status')
            .then(response => {
                console.log("load payment-status response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({paymentStatusList: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input placeholder="Email"
                           className="search_input"
                           onChange={(event) => this.setQueryParam('email', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="Hash"
                           className="search_input"
                           onChange={(event) => this.setQueryParam('hash', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="Blockchain"
                            allowClear={true}
                            onChange={(value) => this.setQueryParam('blockchain', value)}>
                        <Option key="ERC20">ERC20</Option>
                        <Option key="BSC">BSC</Option>
                        <Option key="HECO">HECO</Option>
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="Token"
                            allowClear={true}
                            onChange={(value) => this.setQueryParam('tokenName', value)}>
                        <Option key="USDT">USDT</Option>
                        <Option key="USDC">USDC</Option>
                        <Option key="SHIB">SHIB</Option>
                        <Option key="HIP">HIP</Option>
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="Status"
                            allowClear={true}
                            onChange={(value) => this.setQueryParam('paymentStatus', value)}>
                        {this.state.paymentStatusList.map(item => (
                            <Option key={item.value}>{item.key}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"  icon="search" className="search_btn" loading={this.state.loading}
                            onClick={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}>
                        Search
                    </Button>
                </div>

                <Table loading={this.state.loading}
                       rowKey={'orderId'}
                       columns={[
                           {title: 'Email', dataIndex: 'email', align: 'center'},
                           {title: 'Product', dataIndex: 'purchasePlanName', align: 'center'},
                           {title: 'Amount($)', dataIndex: 'amount', align: 'right' },
                           {title: 'Blockchain', dataIndex: 'blockchain', align: 'center' },
                           {title: 'TokenName', dataIndex: 'tokenName', align: 'center' },
                           {title: 'TokenAmount', dataIndex: 'tokenAmount', align: 'right' },
                           {title: 'TokenPrice', dataIndex: 'tokenPrice', align: 'right' },
                           {title: 'Status', dataIndex: 'paymentStatusText', align: 'center' },
                           {title: 'PaymentTime', dataIndex: 'paymentTime', align: 'center'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               width: 210,
                               render: (text, record) => (
                                   <span style={{whiteSpace: 'nowrap'}}>
                                       <Button type="link" style={{height: 'auto', padding: 0}}
                                               onClick={() => this.showInfoModal(record)}>View</Button>
                                       <Divider type="vertical"/>
                                       <Button type="link" style={{height: 'auto', padding: 0}}
                                               onClick={() => this.loadUserResources(record.userId)}>Resources</Button>
                                       <Divider type="vertical"/>
                                       <Button type="link" style={{height: 'auto', padding: 0}}
                                               disabled={this.isSucceededOrder(record)}
                                               title={this.isSucceededOrder(record) ?
                                                   'Succeeded orders cannot be edited' : 'Edit crypto order'}
                                               onClick={() => this.openEditOrderModal(record)}>Edit</Button>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.total,
                           onChange: (currentPage, pageSize) => {
                               this.setState({loading: true});
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: ((total) => {
                               return `total of ${total} records`;
                           }),
                           className: "pagination"
                       }}/>

                <Modal
                    title="Order Info"
                    width={700}
                    footer={null}
                    visible={this.state.showOrderInfoDialog}
                    onCancel={() => this.setState({showOrderInfoDialog: false})}>
                        <p><Tag color="cyan">Order ID:</Tag> {this.state.selectedOrder.orderId}</p>
                        <p><Tag color="cyan">User ID:</Tag> {this.state.selectedOrder.userId}</p>
                        <p><Tag color="cyan">Email:</Tag> {this.state.selectedOrder.email}</p>
                        <p><Tag color="cyan">Plan Name:</Tag> {this.state.selectedOrder.purchasePlanName}</p>
                        <p><Tag color="cyan">Amount:</Tag> ${this.state.selectedOrder.amount}</p>
                        <p><Tag color="cyan">Blockchain:</Tag> {this.state.selectedOrder.blockchain}</p>
                        <p><Tag color="cyan">TokenName:</Tag> {this.state.selectedOrder.tokenName}</p>
                        <p><Tag color="cyan">TokenAmount:</Tag> {this.state.selectedOrder.tokenAmount}</p>
                        <p><Tag color="cyan">TokenPrice:</Tag> ${this.state.selectedOrder.tokenPrice}</p>
                        <p><Tag color="cyan">ReceiptAddress:</Tag> {this.state.selectedOrder.receiptAddress}</p>
                        <p><Tag color="cyan">PaymentAddress:</Tag> {this.state.selectedOrder.paymentAddress}</p>
                        <p><Tag color="cyan">Hash:</Tag> {this.state.selectedOrder.hash}</p>
                        <p><Tag color="cyan">Payment Status:</Tag> {this.state.selectedOrder.paymentStatusText}</p>
                        <p><Tag color="cyan">Payment Time:</Tag> {this.state.selectedOrder.paymentTime}</p>
                        <p><Tag color="cyan">Created Time:</Tag> {this.state.selectedOrder.createdTime}</p>
                        <p><Tag color="cyan">Remarks:</Tag> {this.state.selectedOrder.errorMessage}</p>
                </Modal>

                <Modal
                    title="Edit Crypto Order"
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={this.state.showEditOrderModal}
                    onCancel={() => this.setState({showEditOrderModal: false})}
                    onOk={() => this.updateCryptoOrder()}
                    confirmLoading={this.state.editLoading}
                    okText="Save"
                    cancelText="Cancel">
                    <Form layout="vertical">
                        <Form.Item label="Blockchain" required={true}>
                            <Select className="width_100"
                                    value={this.state.edit_order_params.blockchain}
                                    onChange={(value) => this.setEditOrderParam('blockchain', value)}>
                                {blockchainList.map(blockchain => (
                                    <Option key={blockchain} value={blockchain}>{blockchain}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Token Name" required={true}>
                            <Input value={this.state.edit_order_params.tokenName || ''}
                                   onChange={(event) => this.setEditOrderParam('tokenName', event.target.value)}/>
                        </Form.Item>
                        <Form.Item label="Token Amount" required={true}>
                            <InputNumber className="width_100"
                                         min={0.000001}
                                         step={0.000001}
                                         precision={6}
                                         value={this.state.edit_order_params.tokenAmount}
                                         onChange={(value) => this.setEditOrderParam('tokenAmount', value)}/>
                        </Form.Item>
                        <Form.Item label="Payment Status" required={true} style={{marginBottom: 0}}>
                            <Select className="width_100"
                                    value={this.state.edit_order_params.paymentStatus}
                                    onChange={(value) => this.setEditOrderParam('paymentStatus', value)}>
                                {paymentStatusList.map(status => (
                                    <Option key={status.value} value={status.value}>{status.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="User Resources"
                    width={800}
                    footer={null}
                    visible={this.state.showResourcesDialog}
                    onCancel={() => this.setState({showResourcesDialog: false})}>
                    <Table loading={this.state.loading}
                           rowKey={'id'}
                           dataSource={this.state.resources}
                           columns={[
                               {title: 'Days', dataIndex: 'availableDays', align: 'center'},
                               {title: 'ExpireTime', dataIndex: 'expireTime', align: 'center'},
                               {title: 'createdTime', dataIndex: 'createdTime', align: 'center'},
                               {title: 'Remarks', dataIndex: 'remarks', align: 'left'}
                           ]}/>
                </Modal>

            </div>
        )
    }

    showInfoModal(row){
        this.setState({
            showOrderInfoDialog: true,
            selectedOrder: row
        })
    };

}
